// batch が保存する time_code の形式（MM:SS、秒は 00〜59）。
// batch/src/shared/transcription/models.py の TranscriptionEntry.time_code の検証に対応する
const TIME_CODE_PATTERN = /^(\d{2}):([0-5]\d)$/;

/**
 * 文字起こしの time_code（MM:SS）を秒数に変換する
 * @returns 秒数。形式に一致しない場合は null
 */
export const parseTimeCode = (timeCode: string): number | null => {
  const match = TIME_CODE_PATTERN.exec(timeCode);
  if (match === null) {
    return null;
  }
  const [, minutes, seconds] = match;
  return Number(minutes) * 60 + Number(seconds);
};
